<style scoped>
@import url("../assets/css/catalog.css");
</style>

<template>
    <div class="catalog">
        <van-tabs color='#ee0a24' title-active-color='#FA5722' title-inactive-color='#323333' line-height='4px' line-width='74px' @change="gotop">
            <van-tab v-for="(item,index) in booksArr" :title="item.category" :key='index'>
                <div class="list" v-for="(litem,lindex) in item.list" :key='lindex'>
                    <span class="list_num">{{lindex+1}}.&nbsp;</span>
                    <span class="list_ce">{{litem.books}}</span>
                    <span :class="[lenArr[index][lindex]?'list_name2':'list_name1','list_name']">{{litem.name}}</span>
                    <span class="list_author" v-if="litem.author==null">不详</span>
                    <span class="list_author" v-else>{{litem.author}}</span>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import data from '../../static/books.json'
export default {
    data(){
        return {
            booksArr:[],
            lenArr:[]
        }
    },
    created(){
        this.booksArr = data
        this.loadbooks()
    },
    methods:{
        loadbooks(){
            for(var i=0;i<this.booksArr.length;i++){
                var list = this.booksArr[i].list
                this.lenArr[i] = []
                for(var j=0;j<list.length;j++){
                    var ce = list[j].books
                    var rt= /(.+)?(?:\(|（)(.+)(?=\)|）)/.exec(ce);
                    if(rt){
                        this.booksArr[i].list[j].books = rt[1]+rt[2]
                        var num = parseInt(rt[1])
                        if(num>99){
                            this.lenArr[i].push(true)
                        }else{
                            this.lenArr[i].push(false)
                        }
                    }else{
                        this.booksArr[i].list[j].books += '册'
                        var num = parseInt(this.booksArr[i].list[j].books)
                        if(num>99){
                            this.lenArr[i].push(true)
                        }else{
                            this.lenArr[i].push(false)
                        }
                    }
                }
            }
        },
        gotop(){
            window.scrollTo(0,0)
        }
    },
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs
    }
}
</script>


// WEBPACK FOOTER //
// src/components/catalog.vue